import React, { useState } from 'react';

export default function ChatOverlay({ activeMember, onClose }) {
  const [messages, setMessages] = useState([
    { id: 1, sender: activeMember?.name, text: 'Hello, what are you working on today?', time: '10:00 AM' }
  ]);
  const [inputMessage, setInputMessage] = useState('');

  if (!activeMember) return null;

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (!inputMessage.trim()) return;
    setMessages([
      ...messages,
      {
        id: Date.now(),
        sender: 'You',
        text: inputMessage,
        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      }
    ]);
    setInputMessage('');
  };

  return (
    <div className="fixed bottom-6 right-6 w-80 lg:w-96 glass-panel rounded-2xl shadow-2xl flex flex-col z-50 transform transition-all duration-300 ease-in-out border border-[rgba(235,190,174,0.2)]" style={{ maxHeight: '600px', height: 'calc(100vh - 120px)' }}>
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-[rgba(235,190,174,0.1)]">
        <div className="flex items-center gap-3">
          <img src={activeMember.avatar} alt={activeMember.name} className="w-10 h-10 rounded-full object-cover border border-[rgba(235,190,174,0.3)]" />
          <div>
            <h3 className="text-aether-light font-playfair font-semibold text-lg">{activeMember.name}</h3>
            <p className="text-aether-gold text-xs">{activeMember.role}</p>
          </div>
        </div>
        <button onClick={onClose} className="text-aether-light hover:text-aether-gold transition-colors">
          <span className="material-symbols-outlined">close</span>
        </button>
      </div>

      {/* Chat History */}
      <div className="flex-1 overflow-y-auto p-4 space-y-4 cosmic-scroll">
        {messages.map((msg) => (
          <div key={msg.id} className={`flex flex-col ${msg.sender === 'You' ? 'items-end' : 'items-start'}`}>
            <span className="text-[10px] text-aether-light/50 mb-1">{msg.sender} • {msg.time}</span>
            <div className={`px-4 py-2 rounded-2xl max-w-[85%] ${msg.sender === 'You' ? 'bg-gradient-to-br from-[rgba(235,190,174,0.2)] to-[rgba(196,164,153,0.1)] text-aether-light rounded-br-none border border-[rgba(235,190,174,0.3)]' : 'bg-[rgba(255,255,255,0.05)] text-aether-light rounded-bl-none border border-[rgba(255,255,255,0.1)]'}`}>
              <p className="text-sm font-light leading-relaxed">{msg.text}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Input Area */}
      <form onSubmit={handleSendMessage} className="p-4 border-t border-[rgba(235,190,174,0.1)] flex items-center gap-2">
        <input 
          type="text" 
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          placeholder={`Message ${activeMember.name}...`} 
          className="flex-1 bg-[rgba(0,0,0,0.2)] border border-[rgba(255,255,255,0.1)] focus:border-[rgba(235,190,174,0.4)] rounded-full px-4 py-2 text-sm text-aether-light outline-none transition-all placeholder:text-aether-light/30"
        />
        <button type="submit" className="w-10 h-10 rounded-full bg-gradient-to-br from-[rgba(235,190,174,0.2)] to-[rgba(196,164,153,0.1)] flex items-center justify-center text-aether-gold hover:text-white border border-[rgba(235,190,174,0.3)] transition-colors">
          <span className="material-symbols-outlined text-sm">send</span>
        </button>
      </form>
    </div>
  );
}
